import React from 'react';
import { Carousel } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { Row, Col, } from 'react-bootstrap';
import slide1 from "../../assets/img/slide/slide-1.jpg";
import slide2 from "../../assets/img/slide/slide-2.jpg";
import slide3 from "../../assets/img/slide/slide-3.jpeg";

const SlideCarousel = () => {
    return (
        <>
            <div className="w-full my-5">
                <Carousel interval={5000}>
                    <Carousel.Item>
                        <div className="relative">
                            <img
                                className="w-full h-[400px] sm:h-[400px] md:h-[500px] lg:h-[600px] xl:h-[850px] object-cover"
                                src={slide1}
                                alt="First slide"
                            />
                            <Carousel.Caption className="absolute bottom-4 left-1/2 transform -translate-x-1/2 w-11/12 bg-gray-900 bg-opacity-40 p-4 rounded-lg font-outfit">
                                <div className="text-sm sm:text-base md:text-lg lg:text-xl font-bold">
                                    Welcome to <span>OASIS Educational Institute</span>
                                </div>

                                <p className="text-xs sm:text-xs md:text-base lg:text-lg mt-2 ">
                                    Our purpose is to provide a safe, happy environment for your child, where they are able to be themselves and thrive; while acquiring the educational foundation needed to achieve.
                                </p>

                                <div className="mt-2 sm:mt-4">
                                    <Link
                                        to="/about"
                                        className="text-blue-500 hover:text-blue-700 text-xs sm:text-sm md:text-base lg:text-lg"
                                    >
                                        Read More
                                    </Link>
                                </div>
                            </Carousel.Caption>
                        </div>
                    </Carousel.Item>

                    <Carousel.Item>
                        <div className="relative">
                        <img
                                className="w-full h-[400px] sm:h-[400px] md:h-[500px] lg:h-[600px] xl:h-[850px] object-cover"
                                src={slide2}
                                alt="Second slide"
                            />
                            <Carousel.Caption className="absolute bottom-4 left-1/2 transform -translate-x-1/2 w-11/12 bg-gray-900 bg-opacity-30 p-4 rounded-lg font-outfit">
                                <div className="text-sm sm:text-base md:text-lg lg:text-xl font-bold">
                                    Welcome to <span>OASIS Educational Institute</span>
                                </div>

                                <p className="text-xs sm:text-xs md:text-base lg:text-lg mt-2 ">
                                    Our purpose is to provide a safe, happy environment for your child, where they are able to be themselves and thrive; while acquiring the educational foundation needed to achieve.
                                </p>

                                <div className="mt-2 sm:mt-4">
                                    <Link
                                        to="/about"
                                        className="text-blue-500 hover:text-blue-700 text-xs sm:text-sm md:text-base lg:text-lg"
                                    >
                                        Read More
                                    </Link>
                                </div>
                            </Carousel.Caption>
                        </div>
                    </Carousel.Item>

                    <Carousel.Item>
                        <div className="relative">
                        <img
                                className="w-full h-[400px] sm:h-[400px] md:h-[500px] lg:h-[600px] xl:h-[850px] object-cover"
                                src={slide3}
                                alt="Third slide"
                            />
                            <Carousel.Caption className="absolute bottom-4 left-1/2 transform -translate-x-1/2 w-11/12 bg-gray-900 bg-opacity-40 p-4 rounded-lg font-outfit">
                                <div className="text-sm sm:text-base md:text-lg lg:text-xl font-bold">
                                    Welcome to <span>OASIS Educational Institute</span>
                                </div>

                                <p className="text-xs sm:text-xs md:text-base lg:text-lg mt-2 ">
                                    Our purpose is to provide a safe, happy environment for your child, where they are able to be themselves and thrive; while acquiring the educational foundation needed to achieve.
                                </p>

                                <div className="mt-2 sm:mt-4">
                                    <Link
                                        to="/about"
                                        className="text-blue-500 hover:text-blue-700 text-xs sm:text-sm md:text-base lg:text-lg"
                                    >
                                        Read More
                                    </Link>
                                </div>
                            </Carousel.Caption>
                        </div>
                    </Carousel.Item>
                </Carousel>
            </div>
  




        </>
    )
}

export default SlideCarousel